<template>
  <footer class="footer-container">
    <div class="footer-content">
      <!-- 电脑端布局 -->
      <el-row :gutter="20" class="desktop-footer">
        <el-col
            v-for="(section, index) in footerSections"
            :key="index"
            :xs="24"
            :sm="12"
            :md="section.title === '联系我们' ? 8 : 4"
            class="footer-section"
        >
          <h3 class="footer-title">{{ section.title }}</h3>
          <ul class="footer-list">
            <li v-for="(item, itemIndex) in section.items" :key="itemIndex">
              <a
                  v-if="item.link"
                  :href="item.link"
                  class="footer-link"
                  @click.prevent="navigateTo(item.link)"
              >
                {{ item.name }}
              </a>
              <span v-else class="contact-item">
                <i :class="item.icon" class="contact-icon"></i>
                <span class="contact-text">{{ item.text }}</span>
              </span>
            </li>
          </ul>
        </el-col>
      </el-row>

      <!-- 手机端折叠菜单 -->
      <div class="mobile-accordion">
        <div
            v-for="(section, index) in footerSections"
            :key="'mobile-'+index"
            class="accordion-item"
            :class="{ active: activeSection === index }"
        >
          <div class="accordion-header" @click="toggleSection(index)">
            <h3 class="footer-title">{{ section.title }}</h3>
            <i class="el-icon-arrow-down accordion-icon"></i>
          </div>
          <div class="accordion-content">
            <ul class="footer-list">
              <li v-for="(item, itemIndex) in section.items" :key="itemIndex">
                <a
                    v-if="item.link"
                    :href="item.link"
                    class="footer-link"
                    @click.prevent="navigateTo(item.link)"
                >
                  {{ item.name }}
                </a>
                <span v-else class="contact-item">
                  <i :class="item.icon" class="contact-icon"></i>
                  <span class="contact-text">{{ item.text }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权信息 -->
    <div class="footer-bottom">
      <p class="copyright">
        &copy; {{ currentYear }} 格里弗(成都)光电科技有限公司
        <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">蜀ICP备2024086608号</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      activeSection: null,
      footerSections: [
        {
          title: "战略合作",
          items: [
            {name: "希达电子", link: "https://ccxida.com/", external: true}
          ]
        },
        {
          title: "产品中心",
          items: [
            {name: "希达倒装COB小间距显示屏", link: "Product"},
            {name: "超高清LED智慧一体机", link: "Product"}
          ]
        },
        {
          title: "案例中心",
          items: [
            {name: "智慧校园案例", link: "CaseShow"},
            {name: "智慧办公案例", link: "CaseShow"}
          ]
        },
        {
          title: "服务与支持",
          items: [
            {name: "关于我们", link: "About"},
            {name: "技术支持", link: "Support"}
          ]
        },
        {
          title: "联系我们",
          items: [
            {icon: "el-icon-phone", text: "+86 028-84790343"},
            {icon: "el-icon-location", text: "中国成都市"}
          ]
        }
      ]
    };
  },
  methods: {
    toggleSection(index) {
      this.activeSection = this.activeSection === index ? null : index;
    },
    closeAllSections() {
      this.activeSection = null;
    },
    navigateTo(path) {
      if (path.startsWith('http')) {
        window.open(path, '_blank');
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  background-color: #2c3e50;
  color: #ffffff;
  padding: 40px 0 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.footer-content {
  max-width: 1700px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 电脑端布局样式 */
.desktop-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.footer-section {
  margin-bottom: 30px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 联系我们部分 */
.footer-section:last-child {
  flex: 0 0 30%;
  max-width: 15%;
  padding-left: 10px;
}

/* 服务与支持部分 */
.footer-section:nth-last-child(2) {
  flex: 0 0 18%;
  max-width: 16%;
  padding-right: 10px;
}

/* 其他部分 */
.footer-section:not(:nth-last-child(2)):not(:last-child) {
  flex: 0 0 13%;
  max-width: 13%;
}

.footer-title {
  font-size: 1.125rem;
  margin-bottom: 1.25rem;
  color: #ffffff;
  font-weight: 600;
  position: relative;
  padding-bottom: 0.5rem;
  width: 100%;
  text-align: center;
}

.footer-title::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: #3498db;
}

/* 手机端折叠菜单样式 - 默认隐藏 */
.mobile-accordion {
  display: none;
  width: 100%;
}

.mobile-accordion .accordion-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-accordion .accordion-item .accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
}

.mobile-accordion .accordion-item .accordion-header .accordion-icon {
  transition: transform 0.3s ease;
}

.mobile-accordion .accordion-item.active .accordion-icon {
  transform: rotate(180deg);
}

.mobile-accordion .accordion-item.active .accordion-content {
  max-height: 500px;
  padding-bottom: 10px;
}

.mobile-accordion .accordion-item .accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

/* 共用列表样式 */
.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.footer-list li {
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #bdc3c7;
  line-height: 1.5;
  text-align: center;
}

.footer-link {
  color: #bdc3c7;
  text-decoration: none;
  display: block;
  padding: 8px 0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.footer-link:hover {
  color: #ffffff;
  transform: translateX(5px);
}

.contact-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}

.contact-icon {
  margin-right: 8px;
  color: #3498db;
  font-size: 1rem;
  flex-shrink: 0;
}

.contact-text {
  text-align: left;
}

.footer-bottom {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  margin-top: 30px;
  text-align: center;
}

.copyright {
  font-size: 0.8125rem;
  color: #bdc3c7;
  margin: 0;
  line-height: 1.5;
}

.icp-link {
  color: #bdc3c7;
  text-decoration: none;
  margin-left: 10px;
  transition: color 0.3s ease;
  cursor: pointer;
}

.icp-link:hover {
  color: #3498db;
}

/* 响应式布局 - 仅针对手机端 */
@media (max-width: 767.98px) {
  .footer-container {
    padding: 20px 0 0;
  }

  .desktop-footer {
    display: none;
  }

  .mobile-accordion {
    display: block;
  }

  .footer-title {
    font-size: 1rem;
    margin-bottom: 0;
    padding-bottom: 0;
    text-align: left;
  }

  .footer-title::after {
    display: none;
  }

  .footer-list li {
    text-align: left;
  }

  .footer-link, .contact-item {
    padding: 8px 15px;
    justify-content: flex-start;
  }

  .footer-bottom {
    margin-top: 20px;
    padding: 15px 0;
  }

  .mobile-accordion .accordion-item .accordion-header {
    padding: 12px 10px;
  }
}

@media (max-width: 575.98px) {
  .footer-container {
    padding: 15px 0 0;
  }

  .footer-content {
    padding: 0 10px;
  }

  .copyright {
    font-size: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .icp-link {
    margin-left: 0;
  }

  .mobile-accordion .accordion-item .accordion-header {
    padding: 10px 8px;
  }

  .mobile-accordion .accordion-item .footer-link,
  .mobile-accordion .accordion-item .contact-item {
    padding: 6px 8px;
  }
}
</style>
